export default function Marquee({ items, speed = 26, dark = true }) {
  const doubled = [...items, ...items];
  return (
    <div className={dark ? 'marquee-strip' : ''} style={!dark ? { overflow:'hidden' } : {}}>
      <div
        className={dark ? 'marquee-track' : 'client-track'}
        style={{ animationDuration: `${speed}s` }}
      >
        {doubled.map((item, i) => (
          <div key={i} className={dark ? 'marquee-item' : 'client-item'}>
            <span className={dark ? 'marquee-dot' : 'client-dot'} />
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
